<template>
    <div class="modal">
        <div class="modal-wrap">
            <div class="modal-inner">
                <h2 class="modal-title">
                    Saved Searches
                    <span class="close" @click="$emit('close')">X</span>
                </h2>

                <div class="modal-inner-scroll">
                    <div v-if="loading" class="center">
                        Loading...
                    </div>
                    
                    <div v-else-if="searches.length === 0" class="center">
                        No saved searches found
                    </div>
                    
                    <div v-else class="saved-searches-list">
                        <div v-for="search in searches" :key="search._id" class="saved-search-item">
                            <span class="name">{{ search.name }}</span>
                            <div class="actions">
                                <font-awesome-icon
                                    icon="play"
                                    class="run"
                                    @click="$emit('run', search)"
                                    title="Run Search"
                                />
                                <font-awesome-icon
                                    icon="trash-can"
                                    class="delete"
                                    @click="confirmDelete(search._id)"
                                    title="Delete Search"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from './../../services/api.service'
export default {
    name: "SavedSearchesModal",
    
    props: {
        savedSearchType: {
            type: String,
            required: true
        },
		searches: {
			type: Array,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
    },
    data() {
        return { };
    },
    
    methods: {
        
        confirmDelete(searchId) {
			this.$dialog
				.confirm( "Are you sure you want to delete this saved search?", { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					this.$emit('delete', searchId);

				}.bind(this))
				.catch(function() {});
        }
    }
};
</script>

<style lang="less" scoped>
.saved-searches-list {
    .saved-search-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #eee;
        
        &:last-child {
            border-bottom: none;
        }
        
        .name {
            flex: 1;
        }
        
        .actions {
            display: flex;
            gap: 10px;
            
            svg {
                cursor: pointer;
                
                &:hover {
                    opacity: 0.7;
                }
            }
            
            .run {
                color: #4CAF50;
            }
            
            .delete {
                color: #f44336;
            }
        }
    }
}

.center {
    text-align: center;
    padding: 20px;
}
</style> 